export default __webpack_public_path__ + "static/media/anodizing-icon.94f049f4.svg";